import _countries from '@/json/countries.json';

export const countries = async () => {
    return new Promise((resolve) => {
        return setTimeout(resolve.bind(null, {data: _countries}), 50)
    });
}
